module.exports = __webpack_public_path__ + "static/media/clothes-5.99c256b5.jpg";